/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { Div } from 'glamorous';
import { IN_PROGRESS } from 'app/constants/challengeStatusTypes';
import LeaderRow from './LeaderRow';

type Props = {
  avatar: Object,
  countryImage?: string,
  displayCountry: boolean,
  displayPlayersCount: boolean,
  dynamicColumn: string,
  id: string,
  isUltimateChampion: boolean,
  name: string,
  onEntrySelect: string => void,
  prize?: string,
  playersCount?: Array<*>,
  rank: number,
  score: number
};

const defaultProps = {
  countryImage: undefined,
  playersCount: undefined
};

function MyLeaderRow({
  avatar,
  countryImage,
  displayCountry,
  displayPlayersCount,
  dynamicColumn,
  id,
  isUltimateChampion,
  name,
  onEntrySelect,
  playersCount,
  prize,
  rank,
  score
}: Props) {
  return (
    <Div marginBottom={10} borderBottom="2px solid black">
      <LeaderRow
        avatar={avatar}
        countryImage={countryImage}
        displayCountry={displayCountry}
        displayPlayersCount={displayPlayersCount}
        dynamicColumn={dynamicColumn}
        id={id}
        name={name}
        prize={prize}
        rank={rank}
        score={score}
        onClick={onEntrySelect}
        playersCount={playersCount}
        isHighlighted
        isUltimateChampion={isUltimateChampion}
      />
    </Div>
  );
}

MyLeaderRow.defaultProps = defaultProps;

function mapStateToProps(state, { showProjected }) {
  return {
    avatar: state.entry.myEntry.avatar,
    countryImage: state.entry.myEntry.countryImage,
    displayCountry: state.settings.displayCountry,
    id: state.entry.myEntry.id,
    isUltimateChampion: !!state.entry.myEntry.isUltimateChampion,
    name: state.entry.myEntry.userName,
    playersCount: state.entry.myEntry.playersCount
      ? state.entry.myEntry.playersCount.filter(status => status.id <= IN_PROGRESS)
      : undefined,
    prize: showProjected ? state.entry.myEntry.prizeProjected : state.entry.myEntry.prize,
    rank: showProjected ? state.entry.myEntry.rankProjected : state.entry.myEntry.rank,
    score: showProjected ? state.entry.myEntry.scoreProjected : state.entry.myEntry.score
  };
}

export default connect(mapStateToProps)(MyLeaderRow);
